import { useEffect } from "react";
import { setCookie } from "nookies";
import { BookMarkProvider } from "./context/BookMarkContainer";
import { ConfigProvider } from "./context/Config";
import { ExportIdProvider } from "./context/ExportId";
import { FilterBarProvider } from "./context/FilterBar";
import { FiltersProvider } from "./context/Filters";
import { LeftBarProvider } from "./context/LeftBar";
import { ModalProvider } from "./context/Modal";
import { QlikProvider } from "./context/Qlik";
import { SelectionsProvider } from "./context/Selections";
import Layout from "./pages/Layout";
import "./style.scss";
import { datadogRum } from "@datadog/browser-rum";

function App() {
  const query = new URLSearchParams(window.location.search);
  if (query.get("u")) {
    setCookie(null, "userHash", query.get("u"), {
      path: "/",
      maxAge: 72576000,
      secure: true,
      domain: ".mtrix.com.br",
    });
  }
  const config = {
    host: process.env.REACT_APP_HOST,
    prefix: process.env.REACT_APP_PREFIX,
    port: isNaN(Number(process.env.REACT_APP_PORT))
      ? process.env.REACT_APP_PORT
      : Number(process.env.REACT_APP_PORT),
    isSecure:
      process.env.REACT_APP_IS_SECURE === "true" ||
      process.env.REACT_APP_IS_SECURE,
  };

  useEffect(() => {
    if (process.env.REACT_APP_DATADOG === "prod") {
      datadogRum.init({
        applicationId: "3aff2253-be37-4170-8e90-6c19a2a9cc19",
        clientToken: "pub08ddcacfd292253a057c5f3d401a42e9",
        site: "us5.datadoghq.com",
        service: "pernod-acuracidade",
        env: "prod",
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
      });
    }
  }, []);

  return (
    <QlikProvider config={config}>
      <SelectionsProvider>
        <BookMarkProvider>
          <ModalProvider>
            <FilterBarProvider>
              <LeftBarProvider>
                <ConfigProvider>
                  <FiltersProvider>
                    <ExportIdProvider>
                      <Layout />
                    </ExportIdProvider>
                  </FiltersProvider>
                </ConfigProvider>
              </LeftBarProvider>
            </FilterBarProvider>
          </ModalProvider>
        </BookMarkProvider>
      </SelectionsProvider>
    </QlikProvider>
  );
}

export default App;
